import axios from 'axios'

const baseurl = `${process.env.VUE_APP_API_URL}`
const url = `${baseurl}/api/v1`
class StageThreeService {
  static getStageThree (id) {
    return axios.get(`${url}/admin/stage-three/fetch/${id}`)
  }
}

export default StageThreeService
